export const COLORS = {
  primary: {
    base: '#7a6020',
    hover: '#614c19',
    pressed: '#4c3b13'
  },

  secondary: {
    text: '#7a6020',
    background: 'transparent',
    hover: '#F7ECDC',
    pressed: '#EDD9B0'
  },

  text: {
    primary: '#FFFFFF',
    secondary: '#676D79',
    error: '#e05c3a'
  },

  border: '#e0d4be'
} as const
